export default __webpack_public_path__ + "static/media/file-lines-light-full.bb12d3f9.svg";